import { En } from 'media-chrome/lang/en.js';
import { Fr } from 'media-chrome/lang/fr.js';
import { Es } from 'media-chrome/lang/es.js';

import deOverridesJson from './de.json';
import frOverridesJson from './fr.json';
import esOverridesJson from './es.json';

export type TranslateDictionary = typeof En;
type PlayerDictionary = Record<keyof TranslateDictionary, string>;
type OverrideDict = Partial<PlayerDictionary>;

const deOverrides = deOverridesJson satisfies OverrideDict;
const frOverrides = frOverridesJson satisfies OverrideDict;
const esOverrides = esOverridesJson satisfies OverrideDict;

export const Translations: {
  de: PlayerDictionary;
  fr: PlayerDictionary;
  es: PlayerDictionary;
} = {
  de: {
    ...En,
    ...deOverrides,
  },
  fr: {
    ...En,
    ...Fr,
    ...frOverrides,
  },
  es: {
    ...En,
    ...Es,
    ...esOverrides,
  },
};
